import { SearchType } from '../components/SearchSummaryCard/internals/helpers'
import { COLORS } from 'parameters/index'
import { Result } from 'generated/api'
import { addDDError } from 'services/AnalyticsLite/Datadog/events'

interface ColorSpace {
	primary: string
	secondary: string
	light: string
}

export const getColorsFromSearchType = (searchType: SearchType): ColorSpace => {
	switch (searchType) {
		case SearchType.hasActiveOffers:
			return { primary: COLORS.MALACHITE_GREEN, secondary: COLORS.ICON_ACTIVE, light: COLORS.GREEN_FILL }
		case SearchType.noOffers:
		case SearchType.expired:
			return { primary: COLORS.SPANISH_GRAY, secondary: COLORS.ICON_INACTIVE, light: COLORS.SPANISH_GRAY }
		case SearchType.inProgress:
			return { primary: COLORS.KSU_PURPLE, secondary: COLORS.ICON_BG_PURPLE, light: 'rgba(89, 43, 134, 0.2)' }
		default:
			return { primary: COLORS.SPANISH_GRAY, secondary: COLORS.ICON_INACTIVE, light: COLORS.SPANISH_GRAY }
	}
}

export enum ResultsStates {
	noOffers = 'noOffers',
	offerList = 'offerList',
	filterable = 'filterable'
}

export const getResultsStatus = (results: Result): ResultsStates => {
	try {
		if (results.offers.length == 0) {
			return ResultsStates.noOffers
		} else if (results.offers.every(p => p.sourceType === 'simple')) {
			return ResultsStates.offerList
		} else {
			return ResultsStates.filterable
		}
	} catch (err) {
		addDDError(err)
		return ResultsStates.noOffers
	}
}
